import React, { useState } from 'react';
import { Star, X } from 'lucide-react';

const GoogleReviewButton = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Replace this URL with your actual Google Business review link
  const googleReviewUrl = "https://g.page/r/CfhrOnK1sUe8EBI/review";

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50">
      <button
        onClick={() => setIsVisible(false)}
        className="absolute -top-2 -right-2 bg-slate-700 text-white rounded-full p-1 hover:bg-slate-800 transition-colors shadow-lg"
        aria-label="Close"
      >
        <X className="w-3 h-3 sm:w-4 sm:h-4" />
      </button>
      
      <a
        href={googleReviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center bg-white rounded-lg shadow-2xl p-3 sm:p-4 hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-slate-200"
      >
        <div className="flex items-center space-x-1 mb-1 sm:mb-2">
          <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span className="font-bold text-slate-900 text-sm sm:text-base">Google</span>
        </div>
        
        <div className="flex mb-1 sm:mb-2">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        
        <div className="text-center">
          <p className="text-xs sm:text-sm font-semibold text-slate-900 mb-0.5 sm:mb-1">Review us on</p>
          <p className="text-xs text-slate-600">Google</p>
        </div>
      </a>
    </div>
  );
};

export default GoogleReviewButton;